import { useContext } from 'react';
import './graphPerYear.style.scss';
import '../pdfComponent.style.scss';
import { PdfContext } from 'utils/context';
import { lengthInInterval, truncateTab } from '../Generics/utilsFunctions';
import { v1 } from 'uuid';
import CropGrossMarginTable from '../Tables/CropGrossMarginTable';
import { useTranslation } from 'react-i18next';

/**
 * @param {string} dataKey
 * @param {boolean} hidePrevious
 */
const GraphPerYearPage = ({ dataKey = 'graphPerYear', hidePrevious = false }) => {
  const { t } = useTranslation();
  const context = useContext(PdfContext);
  const { forecastCampaign } = context;
  const allCharts = context[dataKey] ?? [];

  const isInterculture = dataKey === 'graphInterculturePerYear';

  const charts = hidePrevious && !isInterculture ? allCharts.slice(1) : allCharts;
  if (!charts?.length) return null;
  const numberOfGraphPerPage = 1;
  let toDuplicate = true;
  let repetition = 1;
  const pages = [];

  const indexOffset = isInterculture ? 0 : hidePrevious ? 1 : 0;

  while (toDuplicate) {
    const truncatedResult = truncateTab(charts, numberOfGraphPerPage, repetition);
    const indexGraph = (repetition - 1) * numberOfGraphPerPage;
    pages.push(
      buildGraphPerYear(
        truncatedResult,
        repetition > 1 ? t('simulation.common.continued') : '',
        forecastCampaign,
        indexGraph,
        indexOffset,
        hidePrevious,
        dataKey,
        isInterculture,
        t,
      ),
    );
    lengthInInterval(charts, repetition, numberOfGraphPerPage)
      ? repetition++
      : (toDuplicate = false);
  }

  return pages;
};

const buildGraphPerYear = (
  graphsToRender,
  message,
  forecastCampaign,
  indexGraph,
  indexOffset,
  hidePrevious,
  dataKey,
  isInterculture,
  t,
) => {
  return (
    <article className="pdf-page" key={v1()}>
      <div className="tableau_center">
        <h6 className="title_h6">
          {indexGraph === 0
            ? isInterculture
              ? t('simulation.result.pdf.intercultures.title')
              : t('simulation.result.pdf.production.titleCurrent')
            : isInterculture
              ? t('simulation.result.pdf.intercultures.title')
              : t('simulation.result.pdf.production.title')}
          {indexGraph > 1 ? ` ${message}` : ''}
        </h6>
        <div className="multiple-graph-bloc">
          {graphsToRender?.map((img, idx) => {
            const realIndex = idx + indexGraph + indexOffset;

            const campaignStart = isInterculture
              ? forecastCampaign.startYear + realIndex + 1
              : forecastCampaign.startYear + realIndex - 1;
            const campaignEnd = isInterculture
              ? forecastCampaign.endYear + realIndex + 1
              : forecastCampaign.endYear + realIndex - 1;

            return (
              <div key={v1()}>
                <h6 className="title_campagne">
                  {t('simulation.common.campaign')} {campaignStart} - {campaignEnd}
                </h6>
                <div className="graph">
                  <div className="graphImgContainer">
                    {img ? (
                      <img
                        className="graph-production"
                        src={img}
                        alt={t('simulation.result.pdf.production.graphAlt')}
                      />
                    ) : (
                      <div className="graph-empty">
                        {t('common.noData')}
                      </div>
                    )}
                  </div>
                  {isInterculture ? (
                    <div className="pieChart_table">
                      <CropGrossMarginTable yearIndex={realIndex} filterType="intermediate" />
                    </div>
                  ) : (
                    <div className="pieChart_table">
                      <CropGrossMarginTable yearIndex={realIndex - 1} />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </article>
  );
};

export default GraphPerYearPage;
